"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CountdownTimer = CountdownTimer;
var React = _interopRequireWildcard(require("react"));
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
function calculateTimeLeft(fromTimestamp, timeout) {
  const difference = fromTimestamp - new Date().getTime() + timeout * 1000;
  if (difference > 0) {
    return Math.round(difference / 1000);
  }
  return 0;
}
function CountdownTimer(_ref) {
  let {
    children,
    fromTimestamp,
    timeout,
    onTimeoutExpired
  } = _ref;
  const timerRef = React.useRef();
  const [timeLeft, setTimeLeft] = React.useState(() => calculateTimeLeft(fromTimestamp, timeout));
  React.useEffect(() => {
    timerRef.current = window.setTimeout(() => {
      setTimeLeft(calculateTimeLeft(fromTimestamp, timeout));
    }, 1000);
    return () => {
      window.clearTimeout(timerRef.current);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [timeLeft, fromTimestamp]);
  React.useEffect(() => {
    if (timeLeft === 0 && onTimeoutExpired) {
      onTimeoutExpired();
    }
  }, [timeLeft, onTimeoutExpired]);
  if (!fromTimestamp || !timeout || !timeLeft) {
    return null;
  }
  if (children) {
    return children({
      timeLeft
    });
  }
  return /*#__PURE__*/React.createElement("span", null, timeLeft);
}